// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-light: #f4f9ff;
  --color-white: #ffffff;
  --color-white-2: #FBFCFE;
  --color-primary: #1f68d6;
  --color-primary-2: #3b7ee3;
  --color-primary-3: #ccedff;
  --color-primary-4: #003c97;
  --color-primary-5: #0042A6;
  --color-primary-7: #c1daff;
  --color-primary-8: #97c1ff;
  --color-primary-09: #CCEDFF;
  --color-mima-light: #EEF2F5;
  --color-error: #e12f2f;
  --color-success: #66b032;
  --color-green: #569755;
  --color-green-2: #92e391;
  --color-green-3: #d3eace;
  --color-yellow: #e7d788;
  --color-yellow-2: #ffaa00;
  --color-yellow-3: #8f4f00;
  --color-light-red: #f7d1cd;
  --color-deep-red: #9f0000;
  --color-grey: #b3b3c5;
  --color-grey-2: #d1d1d1;
  --color-grey-3: #e0e9f3;
  --color-grey-4: #D1D1D1;
  --color-grey-5: #EBEBF5;
  --color-grey-6: #9898AB;
  --color-table-grey: #fafafc;
  --color-table-grey-1: #f4f4fc;
  --color-dark: #4a4a68;
  --color-dark-2: #1a1a42;
  --color-dark-3: #696365;
  --color-dark-6: #2a2828;
  --color-disabled: #C0C0C0;
  --color-light-blue: #EBF2FF;
  --color-light-blue-2: #D4E5FF;
  --color-light-blue-3: #E7F3FE;
  --color-dark-yellow: #7E6E1F;
  --color-light-brown: #f4f5f6;
  --color-light-green: #E4FFEC;
  --color-light-yellow: #FFF5D7;
  --color-light-red: #FFE8E8;
  --color-light-grey: #F3F3FF;
  --color-admin: #112855;
  --color-admin-2: #071530;
  --color-admin-3: #020710;
  --default-font-size: 1.8rem;
  --default-font-h1: 6.4rem;
  --default-font-h2: 4rem;
  --default-font-h3: 3.2rem;
  --default-font-subtitle: 2.4rem;
  --default-font-small: 1.4rem;
  --default-font-xsmall: 1.2rem;
}

a {
  text-decoration: none;
}

.ProductDisplay_pageWrapper__X5Aoj {
  width: 70%;
  max-width: 100rem;
  height: 100vh;
  margin: 0 auto;
  padding: 3rem 0;
}
.ProductDisplay_pageWrapper__X5Aoj .ProductDisplay_productContainer__geF9E {
  border: 1px solid var(--color-grey-4);
  border-radius: 3px;
  padding: 35px 40px;
  display: flex;
  gap: 30px;
}
@media only screen and (max-width: 56.25em) {
  .ProductDisplay_pageWrapper__X5Aoj .ProductDisplay_productContainer__geF9E {
    flex-direction: column;
  }
}
.ProductDisplay_pageWrapper__X5Aoj .ProductDisplay_productContainer__photo__4JYzU {
  width: 40%;
}
@media only screen and (max-width: 56.25em) {
  .ProductDisplay_pageWrapper__X5Aoj .ProductDisplay_productContainer__photo__4JYzU {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
.ProductDisplay_pageWrapper__X5Aoj .ProductDisplay_productContainer__photo_lbox__TJbuX {
  width: 100%;
  margin-bottom: 20px;
}
@media only screen and (max-width: 56.25em) {
  .ProductDisplay_pageWrapper__X5Aoj .ProductDisplay_productContainer__photo_lbox__TJbuX {
    text-align: center;
  }
}
.ProductDisplay_pageWrapper__X5Aoj .ProductDisplay_productContainer__photo_lbox_img__g5Qlb {
  display: inline-block;
  width: 100%;
  max-width: 30rem;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}
.ProductDisplay_pageWrapper__X5Aoj .ProductDisplay_productContainer__photo_sbox__\\+mTSa {
  display: flex;
  align-items: center;
  gap: 5px;
}
@media only screen and (max-width: 56.25em) {
  .ProductDisplay_pageWrapper__X5Aoj .ProductDisplay_productContainer__photo_sbox__\\+mTSa {
    justify-content: center;
    align-items: center;
  }
}
.ProductDisplay_pageWrapper__X5Aoj .ProductDisplay_productContainer__photo_sbox_img__GSrjH {
  display: inline-block;
  width: 32%;
  max-width: 9.5rem;
  border-radius: 3px;
  object-fit: cover;
}
@media only screen and (max-width: 56.25em) {
  .ProductDisplay_pageWrapper__X5Aoj .ProductDisplay_productContainer__desc__iCizc {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.ProductDisplay_variations__4Ps4g {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 20px 0;
}
@media only screen and (max-width: 56.25em) {
  .ProductDisplay_variations__4Ps4g {
    justify-content: center;
    align-items: center;
  }
}
.ProductDisplay_variations_variation__Ee55G {
  font-size: 1.3rem;
  padding: 0.5rem;
  border: 1px solid var(--color-dark);
  border-radius: 0.8rem;
  cursor: pointer;
  margin-bottom: 1rem;
}
.ProductDisplay_variations_selectedVariation__RHakX {
  font-size: 1.3rem;
  padding: 0.5rem;
  border: 1px solid var(--color-dark);
  border-radius: 0.8rem;
  cursor: pointer;
  color: var(--color-white);
  font-weight: 700;
  background-color: var(--color-dark);
  margin-bottom: 1rem;
}

.ProductDisplay_deliveryText__2\\+vgg {
  margin-top: auto;
}

.ProductDisplay_ciWrapper__eXzYt {
  width: 80%;
  margin: 0 auto;
  max-width: 120rem;
  padding: 4rem 0;
}
@media only screen and (max-width: 56.25em) {
  .ProductDisplay_ciWrapper__eXzYt {
    width: 90%;
  }
}
@media only screen and (max-width: 31.25em) {
  .ProductDisplay_ciWrapper__eXzYt {
    width: 95%;
    margin: 0 auto;
  }
}
@media only screen and (max-width: 25em) {
  .ProductDisplay_ciWrapper__eXzYt {
    width: 100%;
  }
}

.ProductDisplay_ci__titleBox__ohNQs {
  width: 55%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 10px;
}
@media only screen and (max-width: 56.25em) {
  .ProductDisplay_ci__titleBox__ohNQs {
    width: 60%;
  }
}
@media only screen and (max-width: 43.75em) {
  .ProductDisplay_ci__titleBox__ohNQs {
    width: 85%;
    margin: 0 auto;
  }
}
.ProductDisplay_ci__titleBox__ohNQs svg {
  background-color: var(--color-primary);
  color: var(--color-white);
  width: 3rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: 5px;
  cursor: pointer;
}
.ProductDisplay_ci__container__xGt5r {
  display: flex;
  gap: 30px;
  margin: 35px 0;
}
@media only screen and (max-width: 43.75em) {
  .ProductDisplay_ci__container__xGt5r {
    flex-direction: column;
    align-items: center;
  }
}
.ProductDisplay_ci__details__yTYkc {
  width: 55%;
  border: 1px solid var(--color-grey-4);
  border-radius: 10px;
  padding: 15px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media only screen and (max-width: 56.25em) {
  .ProductDisplay_ci__details__yTYkc {
    width: 60%;
  }
}
@media only screen and (max-width: 43.75em) {
  .ProductDisplay_ci__details__yTYkc {
    width: 85%;
  }
}
@media only screen and (max-width: 31.25em) {
  .ProductDisplay_ci__details__yTYkc {
    width: 95%;
  }
}
.ProductDisplay_ci__summary__F0jqa {
  width: 40%;
  display: flex;
  flex-direction: column;
  gap: 4rem;
}
@media only screen and (max-width: 43.75em) {
  .ProductDisplay_ci__summary__F0jqa {
    width: 80%;
    order: -1;
  }
}
.ProductDisplay_ci__toggle__m5nYl {
  display: flex;
  justify-content: space-between;
  background-color: var(--color-grey-4);
  padding: 10px 5px;
  border-radius: 5px;
  cursor: pointer;
}
.ProductDisplay_ci__order__Ive7U {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding: 10px 0;
}
.ProductDisplay_ci__order__Ive7U:not(:last-child) {
  border-bottom: 1px solid var(--color-grey-4);
}
.ProductDisplay_ci__order_shipping__07T4l {
  display: flex;
  align-items: flex-start;
}
.ProductDisplay_ci__order_shipping__07T4l:not(:last-child) {
  margin-bottom: 2rem;
}
.ProductDisplay_ci__order_payment_details__G25iJ > * {
  display: inline-block;
  margin-bottom: 1rem;
}

.ProductDisplay_ps__container__pQl2b {
  display: flex;
  gap: 20px;
  margin: 20px 0 40px;
}
@media only screen and (max-width: 43.75em) {
  .ProductDisplay_ps__container__pQl2b {
    flex-direction: column;
    align-items: center;
  }
}
.ProductDisplay_ps__order__4JxT4 {
  width: 55%;
}
@media only screen and (max-width: 43.75em) {
  .ProductDisplay_ps__order__4JxT4 {
    width: 80%;
  }
}
@media only screen and (max-width: 25em) {
  .ProductDisplay_ps__order__4JxT4 {
    width: 90%;
  }
}
.ProductDisplay_ps__payment__m18No {
  flex: 1 1;
}
@media only screen and (max-width: 43.75em) {
  .ProductDisplay_ps__payment__m18No {
    width: 80%;
  }
}
@media only screen and (max-width: 25em) {
  .ProductDisplay_ps__payment__m18No {
    width: 90%;
  }
}

.ProductDisplay_mima__CHNmE {
  display: flex;
  align-items: center;
  margin-top: 3rem;
}
.ProductDisplay_mima__CHNmE > :not(:last-child) {
  margin-right: 1rem;
}
.ProductDisplay_mima__logo__r7v8r {
  height: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables/_variables.scss","webpack://./src/assets/styles/ProductDisplay/ProductDisplay.module.scss"],"names":[],"mappings":"AAAA;EAEC,sBAAA;EACA,sBAAA;EACA,wBAAA;EAEA,wBAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EAEA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,wBAAA;EAGA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;EACA,6BAAA;ACTD;;AApDA;EACE,qBAAA;AAuDF;;AApDA;EACE,UAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AAuDF;AArDE;EACE,qCAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AAuDJ;AArDI;EAPF;IAQI,sBAAA;EAwDJ;AACF;AAtDI;EACE,UAAA;AAwDN;AAtDM;EAHF;IAII,WAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;EAyDN;AACF;AAvDM;EACE,WAAA;EACA,mBAAA;AAyDR;AAvDQ;EAJF;IAKI,kBAAA;EA0DR;AACF;AAxDQ;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AA0DV;AAtDM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAwDR;AAtDQ;EALF;IAMI,uBAAA;IACA,mBAAA;EAyDR;AACF;AAvDQ;EACE,qBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAyDV;AAlDI;EAFA;IAGI,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;EAqDN;AACF;;AAhDA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;AAmDF;AAjDE;EANF;IAOI,uBAAA;IACA,mBAAA;EAoDF;AACF;AAlCE;EACE,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;AAoCJ;AAjCE;EACE,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,mCAAA;EACA,mBAAA;AAmCJ;;AA/BA;EACE,gBAAA;AAkCF;;AA/BA;EACE,UAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAkCF;AAhCE;EANF;IAOI,UAAA;EAmCF;AACF;AAjCE;EAVF;IAWI,UAAA;IACA,cAAA;EAoCF;AACF;AAlCE;EAfF;IAgBI,WAAA;EAqCF;AACF;;AAhCE;EACE,UAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,SAAA;AAmCJ;AAjCI;EAPF;IAQI,UAAA;EAoCJ;AACF;AAlCI;EAXF;IAYI,UAAA;IACA,cAAA;EAqCJ;AACF;AAnCI;EACE,sCAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAqCN;AAjCE;EACE,aAAA;EACA,SAAA;EACA,cAAA;AAmCJ;AAjCI;EALF;IAMI,sBAAA;IACA,mBAAA;EAoCJ;AACF;AAjCE;EACE,UAAA;EACA,qCAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAmCJ;AAjCI;EATF;IAUI,UAAA;EAoCJ;AACF;AAlCI;EAbF;IAcI,UAAA;EAqCJ;AACF;AAnCI;EAjBF;IAkBI,UAAA;EAsCJ;AACF;AAnCE;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAqCJ;AAnCI;EANF;IAOI,UAAA;IACA,SAAA;EAsCJ;AACF;AAnCE;EACE,aAAA;EACA,8BAAA;EACA,qCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAqCJ;AAlCE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAoCJ;AAlCI;EACE,4CAAA;AAoCN;AAjCI;EACE,aAAA;EACA,uBAAA;AAmCN;AAjCM;EACE,mBAAA;AAmCR;AA7BM;EACE,qBAAA;EACA,mBAAA;AA+BR;;AAvBE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AA0BJ;AAxBI;EALF;IAMI,sBAAA;IACA,mBAAA;EA2BJ;AACF;AAxBE;EACE,UAAA;AA0BJ;AAxBI;EAHF;IAII,UAAA;EA2BJ;AACF;AAzBI;EAPF;IAQI,UAAA;EA4BJ;AACF;AAzBE;EACE,SAAA;AA2BJ;AAzBI;EAHF;IAII,UAAA;EA4BJ;AACF;AA1BI;EAPF;IAQI,UAAA;EA6BJ;AACF;;AAzBA;EACC,aAAA;EACA,mBAAA;EACA,gBAAA;AA4BD;AA1BC;EACC,kBAAA;AA4BF;AAzBC;EACC,YAAA;AA2BF","sourcesContent":[":root {\n\t//COLORS\n\t--color-light: #f4f9ff;\n\t--color-white: #ffffff;\n\t--color-white-2: #FBFCFE;\n\n\t--color-primary: #1f68d6;\n\t--color-primary-2: #3b7ee3;\n\t--color-primary-3: #ccedff;\n\t--color-primary-4: #003c97;\n\t--color-primary-5: #0042A6;\n\t--color-primary-7: #c1daff;\n\t--color-primary-8: #97c1ff;\n\t--color-primary-09: #CCEDFF;\n\t--color-mima-light: #EEF2F5;\n\n\t--color-error: #e12f2f;\n\t--color-success: #66b032;\n\t--color-green: #569755;\n\t--color-green-2: #92e391;\n\t--color-green-3: #d3eace;\n\t--color-yellow: #e7d788;\n\t--color-yellow-2: #ffaa00;\n\t--color-yellow-3: #8f4f00;\n\t--color-light-red: #f7d1cd;\n\t--color-deep-red: #9f0000;\n\n\t--color-grey: #b3b3c5;\n\t--color-grey-2: #d1d1d1;\n\t--color-grey-3: #e0e9f3;\n\t--color-grey-4: #D1D1D1;\n\t--color-grey-5: #EBEBF5;\n\t--color-grey-6: #9898AB;\n\t--color-table-grey: #fafafc;\n\t--color-table-grey-1: #f4f4fc;\n\n\t--color-dark: #4a4a68;\n\t--color-dark-2: #1a1a42;\n\t--color-dark-3: #696365;\n\t--color-dark-6: #2a2828;\n\n\t--color-disabled: #C0C0C0;\n\t--color-light-blue: #EBF2FF;\n\t--color-light-blue-2: #D4E5FF;\n\t--color-light-blue-3: #E7F3FE;\n\n\t--color-dark-yellow: #7E6E1F;\n\t--color-light-brown: #f4f5f6;\n\t--color-light-green: #E4FFEC;\n\t--color-light-yellow: #FFF5D7;\n\t--color-light-red: #FFE8E8;\n\t--color-light-grey: #F3F3FF;\n\n\t--color-admin: #112855;\n\t--color-admin-2: #071530;\n\t--color-admin-3: #020710;\n\n\t// FONT\n\t--default-font-size: 1.8rem;\n\t--default-font-h1: 6.4rem;\n\t--default-font-h2: 4rem;\n\t--default-font-h3: 3.2rem;\n\t--default-font-subtitle: 2.4rem;\n\t--default-font-small: 1.4rem;\n\t--default-font-xsmall: 1.2rem;\n}\n\n//COLORS\n$color-light: #f4f9ff;\n$color-white: #ffffff;\n$color-white-2: #FBFCFE;\n\n$color-primary: #1f68d6;\n$color-primary-2: #3b7ee3;\n$color-primary-3: #ccedff;\n$color-primary-4: #003c97;\n$color-primary-7: #c1daff;\n$color-primary-09: #CCEDFF;\n\n$color-error: #e12f2f;\n$color-success: #66b032;\n$color-green: #569755;\n$color-green-2: #92e391;\n$color-yellow: #e7d788;\n$color-light-red: #f7d1cd;\n\n$color-grey: #b3b3c5;\n$color-grey-2: #d1d1d1;\n$color-grey-3: #e0e9f3;\n$color-grey-4: #D1D1D1;\n$color-grey-6:#9898AB;\n\n$color-dark: #4a4a68;\n$color-dark-3: #696365;\n$color-dark-6: #2a2828;\n\n// FONT\n$default-font-size: 1.8rem;\n$default-font-h1: 6.4rem;\n$default-font-h2: 4rem;\n$default-font-h3: 3.2rem;\n$default-font-subtitle: 2.4rem;\n$default-font-small: 1.4rem;\n\n// SHADOWS\n$shadow-dark: 0 2rem 6rem rgba(0, 0, 0, 0.3);\n$shadow-light: 0 2rem 5rem rgba(0, 0, 0, 0.06);\n","@import '../variables/breakpoints';\n@import '../variables/variables';\n\na {\n  text-decoration: none;\n}\n\n.pageWrapper {\n  width: 70%;\n  max-width: 100rem;\n  height: 100vh;\n  margin: 0 auto;\n  padding: 3rem 0;\n\n  .productContainer {\n    border: 1px solid var(--color-grey-4);\n    border-radius: 3px;\n    padding: 35px 40px;\n    display: flex;\n    gap: 30px;\n\n    @media only screen and (max-width: $bp-900) {\n      flex-direction: column;\n    }\n\n    &__photo {\n      width: 40%;\n\n      @media only screen and (max-width: $bp-900) {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n      }\n\n      &_lbox {\n        width: 100%;\n        margin-bottom: 20px;\n\n        @media only screen and (max-width: $bp-900) {\n          text-align: center;\n        }\n\n        &_img {\n          display: inline-block;\n          width: 100%;\n          max-width: 30rem;\n          height: 100%;\n          border-radius: 10px;\n          object-fit: cover;\n        }\n      }\n\n      &_sbox {\n        display: flex;\n        align-items: center;\n        gap: 5px;\n\n        @media only screen and (max-width: $bp-900) {\n          justify-content: center;\n          align-items: center;\n        }\n\n        &_img {\n          display: inline-block;\n          width: 32%;\n          max-width: 9.5rem;\n          border-radius: 3px;\n          object-fit: cover;\n        }\n      }\n    }\n\n    &__desc {\n\n    @media only screen and (max-width: $bp-900) {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n}\n\n.variations {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin: 20px 0;\n\n  @media only screen and (max-width: $bp-900) {\n    justify-content: center;\n    align-items: center;\n  }\n\n  // &__box {\n  //   background: var(--color-white);\n  //   padding: 10px 20px;\n  //   border-radius: 5px;\n  //   box-shadow: 0 5px 10px 5px rgba(0, 0, 0, 0.07);\n  //   cursor: pointer;\n  // }\n  // &_item {\n  //   font-size: 1.2rem;\n  //   padding: 0.5rem;\n  //   border: 1px solid var(--color-dark);\n  //   border-radius: 0.8rem;\n  //   cursor: pointer;\n  //   margin-bottom: 1rem;\n  // }\n\n  &_variation {\n    font-size: 1.3rem;\n    padding: 0.5rem;\n    border: 1px solid var(--color-dark);\n    border-radius: 0.8rem;\n    cursor: pointer;\n    margin-bottom: 1rem;\n  }\n\n  &_selectedVariation {\n    font-size: 1.3rem;\n    padding: 0.5rem;\n    border: 1px solid var(--color-dark);\n    border-radius: 0.8rem;\n    cursor: pointer;\n    color: var(--color-white);\n    font-weight: 700;\n    background-color: var(--color-dark);\n    margin-bottom: 1rem;\n  }\n}\n\n.deliveryText {\n  margin-top: auto;\n}\n\n.ciWrapper {\n  width: 80%;\n  margin: 0 auto;\n  max-width: 120rem;\n  padding: 4rem 0;\n\n  @media only screen and (max-width: $bp-900) {\n    width: 90%;\n  }\n\n  @media only screen and (max-width: $bp-500) {\n    width: 95%;\n    margin: 0 auto;\n  }\n\n  @media only screen and (max-width: $bp-400) {\n    width: 100%;\n  }\n}\n\n.ci {\n\n  &__titleBox {\n    width: 55%;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    gap: 10px;\n\n    @media only screen and (max-width: $bp-900) {\n      width: 60%;\n    }\n\n    @media only screen and (max-width: $bp-700) {\n      width: 85%;\n      margin: 0 auto;\n    }\n\n    svg {\n      background-color: var(--color-primary);\n      color: var(--color-white);\n      width: 3rem;\n      height: 3rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border-radius: 50%;\n      padding: 5px;\n      cursor: pointer;\n    }\n  }\n\n  &__container {\n    display: flex;\n    gap: 30px;\n    margin: 35px 0;\n\n    @media only screen and (max-width: $bp-700) {\n      flex-direction: column;\n      align-items: center;\n    }\n  }\n\n  &__details {\n    width: 55%;\n    border: 1px solid var(--color-grey-4);\n    border-radius: 10px;\n    padding: 15px 15px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    @media only screen and (max-width: $bp-900) {\n      width: 60%;\n    }\n\n    @media only screen and (max-width: $bp-700) {\n      width: 85%;\n    }\n\n    @media only screen and (max-width: $bp-500) {\n      width: 95%;\n    }\n  }\n\n  &__summary {\n    width: 40%;\n    display: flex;\n    flex-direction: column;\n    gap: 4rem;\n\n    @media only screen and (max-width: $bp-700) {\n      width: 80%;\n      order: -1;\n    }\n  }\n\n  &__toggle {\n    display: flex;\n    justify-content: space-between;\n    background-color: var(--color-grey-4);\n    padding: 10px 5px;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n\n  &__order {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n    padding: 10px 0;\n\n    &:not(:last-child) {\n      border-bottom: 1px solid var(--color-grey-4);\n    }\n\n    &_shipping {\n      display: flex;\n      align-items: flex-start;\n\n      &:not(:last-child) {\n        margin-bottom: 2rem;\n      }\n    }\n\n    &_payment {\n\n      &_details > * {\n        display: inline-block;\n        margin-bottom: 1rem;\n      }\n    }\n  }\n}\n\n.ps {\n\n  &__container {\n    display: flex;\n    gap: 20px;\n    margin: 20px 0 40px;\n\n    @media only screen and (max-width: $bp-700) {\n      flex-direction: column;\n      align-items: center;\n    }\n  }\n\n  &__order {\n    width: 55%;\n\n    @media only screen and (max-width: $bp-700) {\n      width: 80%;\n    }\n\n    @media only screen and (max-width: $bp-400) {\n      width: 90%;\n    }\n  }\n\n  &__payment {\n    flex: 1;\n\n    @media only screen and (max-width: $bp-700) {\n      width: 80%;\n    }\n\n    @media only screen and (max-width: $bp-400) {\n      width: 90%;\n    }\n  }\n}\n\n.mima {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-top: 3rem;\n\n\t& > :not(:last-child) {\n\t\tmargin-right: 1rem;\n\t}\n\n\t&__logo {\n\t\theight: 3rem;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrapper": `ProductDisplay_pageWrapper__X5Aoj`,
	"productContainer": `ProductDisplay_productContainer__geF9E`,
	"productContainer__photo": `ProductDisplay_productContainer__photo__4JYzU`,
	"productContainer__photo_lbox": `ProductDisplay_productContainer__photo_lbox__TJbuX`,
	"productContainer__photo_lbox_img": `ProductDisplay_productContainer__photo_lbox_img__g5Qlb`,
	"productContainer__photo_sbox": `ProductDisplay_productContainer__photo_sbox__+mTSa`,
	"productContainer__photo_sbox_img": `ProductDisplay_productContainer__photo_sbox_img__GSrjH`,
	"productContainer__desc": `ProductDisplay_productContainer__desc__iCizc`,
	"variations": `ProductDisplay_variations__4Ps4g`,
	"variations_variation": `ProductDisplay_variations_variation__Ee55G`,
	"variations_selectedVariation": `ProductDisplay_variations_selectedVariation__RHakX`,
	"deliveryText": `ProductDisplay_deliveryText__2+vgg`,
	"ciWrapper": `ProductDisplay_ciWrapper__eXzYt`,
	"ci__titleBox": `ProductDisplay_ci__titleBox__ohNQs`,
	"ci__container": `ProductDisplay_ci__container__xGt5r`,
	"ci__details": `ProductDisplay_ci__details__yTYkc`,
	"ci__summary": `ProductDisplay_ci__summary__F0jqa`,
	"ci__toggle": `ProductDisplay_ci__toggle__m5nYl`,
	"ci__order": `ProductDisplay_ci__order__Ive7U`,
	"ci__order_shipping": `ProductDisplay_ci__order_shipping__07T4l`,
	"ci__order_payment_details": `ProductDisplay_ci__order_payment_details__G25iJ`,
	"ps__container": `ProductDisplay_ps__container__pQl2b`,
	"ps__order": `ProductDisplay_ps__order__4JxT4`,
	"ps__payment": `ProductDisplay_ps__payment__m18No`,
	"mima": `ProductDisplay_mima__CHNmE`,
	"mima__logo": `ProductDisplay_mima__logo__r7v8r`
};
export default ___CSS_LOADER_EXPORT___;
